import * as Sentry from '@sentry/react';
import { isProd } from '../utils/isProd.util';
import { getConfig } from 'config';

// Initialize Sentry
export const initSentry = () => {
  Sentry.init({
    dsn: isProd() ? getConfig().sentry.dsn : undefined,
    environment: isProd() ? 'production' : 'development',
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    // Performance Monitoring
    tracesSampleRate: isProd() ? 0.1 : 1.0,
    // Session Replay
    replaysSessionSampleRate: isProd() ? 0.1 : 1.0,
    // Set release version
    release: getConfig().version || 'unknown',
    // Set user context
    beforeSend(event) {
      // Filter out development errors in production
      if (isProd() && event.exception) {
        const error = event.exception.values?.[0];
        if (error?.type === 'ChunkLoadError' || error?.type === 'Loading chunk') {
          return null; // Don't send chunk load errors in production
        }
      }
      return event;
    },
  });
};

// Set user context for Sentry
export const setSentryUser = (user: any) => {
  Sentry.setUser({
    id: user.id,
    email: user.email,
    username: user.username,
  });
};

// Clear user context
export const clearSentryUser = () => {
  Sentry.setUser(null);
};

// Capture exception manually
export const captureException = (error: Error, context?: any) => {
  Sentry.withScope((scope) => {
    if (context) {
      scope.setContext('additional', context);
    }
    Sentry.captureException(error);
  });
};

// Capture message manually
export const captureMessage = (message: string, level: Sentry.SeverityLevel = 'info') => {
  Sentry.captureMessage(message, level);
};
